document.documentElement.classList.remove('no-js');

const Charmant = {
  routes: {
    cart: window.CharmantRoutes?.cart || '/cart',
    add: window.CharmantRoutes?.cartAdd || '/cart/add',
    change: window.CharmantRoutes?.cartChange || '/cart/change',
    collections: window.CharmantRoutes?.collections || '/collections'
  },
  toastTimer: null,
  lastFocused: null,
  money(cents) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format((cents || 0) / 100);
  },
  escape(value = '') {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  },
  toast(message) {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
  },
  closePanels() {
    document.querySelectorAll('[data-mobile-nav], [data-search-panel]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-mobile-toggle], [data-search-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('menu-open');
  },
  async getCart() {
    const response = await fetch(`${this.routes.cart}.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('No se pudo cargar el carrito');
    return response.json();
  },
  itemMarkup(item) {
    const image = item.featured_image?.url || item.image || '';
    const imageUrl = image ? `${image}${image.includes('?') ? '&' : '?'}width=300` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${this.escape(item.variant_title)}</p>` : '';
    return `<article class="cart-drawer__item" data-cart-item-key="${this.escape(item.key)}">
      <a class="cart-drawer__image" href="${this.escape(item.url)}">${imageUrl ? `<img src="${this.escape(imageUrl)}" alt="${this.escape(item.product_title)}" width="120" height="160">` : ''}</a>
      <div class="cart-drawer__item-info"><h3><a href="${this.escape(item.url)}">${this.escape(item.product_title)}</a></h3>${variant}<strong>${this.money(item.final_line_price)}</strong>
        <div class="cart-drawer__item-actions"><div class="quantity-control"><button type="button" data-cart-change="${this.escape(item.key)}" data-quantity="${Math.max(item.quantity - 1, 0)}" aria-label="Reducir cantidad">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${this.escape(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad">+</button></div><button class="cart-drawer__remove" type="button" data-cart-change="${this.escape(item.key)}" data-quantity="0">Eliminar</button></div>
      </div></article>`;
  },
  renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const shell = document.querySelector('[data-cart-drawer-shell]');
    if (!shell) return;
    shell.querySelector('[data-cart-drawer-count]').textContent = `(${cart.item_count})`;
    const items = shell.querySelector('[data-cart-drawer-items]');
    const footer = shell.querySelector('[data-cart-drawer-footer]');
    if (!cart.item_count) {
      items.innerHTML = `<div class="cart-drawer__empty"><p>Tu carrito está esperando una pieza especial.</p><a class="button" href="${this.routes.collections}/dama">EXPLORAR MUJER</a></div>`;
      footer.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map((item) => this.itemMarkup(item)).join('');
    footer.hidden = false;
    footer.querySelector('[data-cart-drawer-total]').textContent = this.money(cart.total_price);
    const freeShippingGoal = 50000000;
    const remaining = Math.max(freeShippingGoal - cart.total_price, 0);
    const shippingMessage = footer.querySelector('[data-cart-shipping-message]');
    const shippingBar = footer.querySelector('[data-cart-shipping-bar]');
    if (shippingMessage) {
      shippingMessage.innerHTML = remaining > 0
        ? `Te faltan <strong>${this.money(remaining)}</strong> para el mínimo de envío gratis en Colombia. <a href="${this.routes.collections}/dama">Descubre más prendas →</a><span class="shipping-progress__terms">Aplica a compras elegibles; se confirma antes de pagar.</span>`
        : '<strong>Tu pedido alcanza el mínimo de $500.000.</strong><span class="shipping-progress__terms">El envío gratis en Colombia se confirma antes de pagar y no se combina con otros descuentos.</span>';
    }
    if (shippingBar) shippingBar.style.width = `${Math.min((cart.total_price / freeShippingGoal) * 100, 100)}%`;
  },
  async refreshCart() {
    const cart = await this.getCart();
    this.renderCart(cart);
    return cart;
  },
  async openCart() {
    const shell = document.querySelector('[data-cart-drawer-shell]');
    if (!shell) return;
    this.lastFocused = document.activeElement;
    shell.removeAttribute('hidden');
    document.body.classList.add('cart-open');
    const items = shell.querySelector('[data-cart-drawer-items]');
    if (items) items.innerHTML = '<div class="cart-drawer__loading" role="status">Cargando tu selección…</div>';
    shell.querySelector('[data-cart-drawer]')?.focus();
    try {
      await this.refreshCart();
    } catch (error) {
      if (items) items.innerHTML = `<div class="cart-drawer__error"><p>No pudimos cargar el carrito en este momento.</p><a class="button" href="${this.routes.cart}">ABRIR CARRITO COMPLETO</a></div>`;
      throw error;
    }
  },
  closeCart() {
    document.querySelector('[data-cart-drawer-shell]')?.setAttribute('hidden', '');
    document.body.classList.remove('cart-open');
    if (this.lastFocused instanceof HTMLElement) this.lastFocused.focus();
  },
  async changeCart(key, quantity) {
    const response = await fetch(`${this.routes.change}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('No se pudo actualizar el carrito');
    // The change response can briefly carry an out-of-date total. Read the
    // canonical cart before displaying the new subtotal and shipping threshold.
    await response.json();
    return this.refreshCart();
  }
};

function showCardGalleryImage(gallery, requestedIndex) {
  if (!gallery || gallery.classList.contains('is-loading')) return;
  const images = [...gallery.querySelectorAll('.product-card__gallery-image')];
  const index = Math.max(0, Math.min(requestedIndex, images.length - 1));
  if (index === Number(gallery.dataset.cardIndex || 0)) return;
  const image = images[index];
  const show = () => {
    images.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === index);
      item.setAttribute('aria-hidden', String(itemIndex !== index));
    });
    gallery.dataset.cardIndex = String(index);
    gallery.querySelector('[data-card-gallery-count]').textContent = `${index + 1} / ${images.length}`;
    gallery.querySelector('[data-card-gallery-step="-1"]').disabled = index === 0;
    gallery.querySelector('[data-card-gallery-step="1"]').disabled = index === images.length - 1;
    gallery.classList.remove('is-loading');
  };
  if (image.complete && image.naturalWidth > 0) { show(); return; }
  gallery.classList.add('is-loading');
  image.addEventListener('load', show, { once: true });
  image.addEventListener('error', () => {
    gallery.classList.remove('is-loading');
    Charmant.toast('No pudimos cargar esa foto. Inténtalo de nuevo.');
  }, { once: true });
  image.loading = 'eager';
  if (image.dataset.src) {
    image.classList.add('is-loaded');
    image.srcset = image.dataset.srcset || '';
    image.src = image.dataset.src;
  }
}

document.querySelectorAll('[data-card-gallery]').forEach((gallery) => {
  gallery.querySelectorAll('.product-card__gallery-image').forEach((image, index) => image.setAttribute('aria-hidden', String(index !== 0)));
});
document.documentElement.classList.add('card-gallery-ready');
document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const stage = gallery.querySelector('.product-gallery__stage');
  const deferredImages = [...gallery.querySelectorAll('[data-product-image-src]')];
  if (!stage || !deferredImages.length) return;
  const loadImage = (image) => {
    if (!image.dataset.productImageSrc) return;
    image.srcset = image.dataset.productImageSrcset || '';
    image.src = image.dataset.productImageSrc;
    delete image.dataset.productImageSrc;
    delete image.dataset.productImageSrcset;
  };
  const desktop = window.matchMedia('(min-width: 641px)');
  if (desktop.matches || !('IntersectionObserver' in window)) {
    deferredImages.forEach(loadImage);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadImage(entry.target);
      observer.unobserve(entry.target);
    });
  }, { root: stage, rootMargin: '0px 100px' });
  deferredImages.forEach((image) => observer.observe(image));
  desktop.addEventListener('change', () => {
    if (!desktop.matches) return;
    observer.disconnect();
    deferredImages.forEach(loadImage);
  }, { once: true });
});
let cardGalleryTouch = null;
document.addEventListener('touchstart', (event) => {
  if (!window.matchMedia('(max-width: 640px)').matches || event.touches.length !== 1) return;
  const link = event.target.closest('[data-card-gallery-link]');
  if (!link) return;
  cardGalleryTouch = { gallery: link.closest('[data-card-gallery]'), x: event.touches[0].clientX, y: event.touches[0].clientY };
}, { passive: true });
document.addEventListener('touchend', (event) => {
  if (!cardGalleryTouch || !event.changedTouches.length) return;
  const { gallery, x, y } = cardGalleryTouch;
  cardGalleryTouch = null;
  const distanceX = event.changedTouches[0].clientX - x;
  const distanceY = event.changedTouches[0].clientY - y;
  if (Math.abs(distanceX) < 35 || Math.abs(distanceX) < Math.abs(distanceY) * 1.2) return;
  event.preventDefault();
  showCardGalleryImage(gallery, Number(gallery.dataset.cardIndex || 0) + (distanceX < 0 ? 1 : -1));
}, { passive: false });
document.addEventListener('touchcancel', () => { cardGalleryTouch = null; }, { passive: true });

function focusProductSizes(root) {
  const fieldset = root?.querySelector('.variant-fieldset');
  if (!fieldset) return;
  fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
  fieldset.querySelector('[data-product-radio]:not(:disabled)')?.focus({ preventScroll: true });
}

let productLightboxTrigger = null;
let productLightboxItems = [];
let productLightboxIndex = 0;
let productLightboxTouchStart = null;
let suppressProductLightboxClickUntil = 0;

function showProductLightboxImage(index) {
  if (index < 0 || index >= productLightboxItems.length) return;
  const lightbox = document.querySelector('[data-product-lightbox]');
  const image = lightbox?.querySelector('[data-product-lightbox-image]');
  if (!lightbox || !image) return;
  productLightboxIndex = index;
  const link = productLightboxItems[index];
  lightbox.classList.remove('is-zoomed');
  lightbox.scrollTo(0, 0);
  image.alt = link.querySelector('img')?.alt || '';
  image.src = link.href;
  const previous = lightbox.querySelector('[data-product-lightbox-step="-1"]');
  const next = lightbox.querySelector('[data-product-lightbox-step="1"]');
  if (previous) previous.disabled = index === 0;
  if (next) next.disabled = index === productLightboxItems.length - 1;
  const count = lightbox.querySelector('[data-product-lightbox-count]');
  if (count) count.textContent = `${index + 1} / ${productLightboxItems.length}`;
  lightbox.classList.toggle('has-multiple-images', productLightboxItems.length > 1);
}

function closeProductLightbox() {
  const lightbox = document.querySelector('[data-product-lightbox]');
  if (!lightbox || lightbox.hidden) return;
  lightbox.hidden = true;
  lightbox.classList.remove('is-zoomed');
  document.body.classList.remove('lightbox-open');
  const image = lightbox.querySelector('[data-product-lightbox-image]');
  if (image) image.removeAttribute('src');
  productLightboxTrigger?.focus({ preventScroll: true });
  productLightboxTrigger = null;
  productLightboxItems = [];
}

document.addEventListener('click', async (event) => {
  const sizePrompt = event.target.closest('[data-buy-now], .product-add');
  if (sizePrompt?.type === 'button') {
    event.preventDefault();
    focusProductSizes(sizePrompt.closest('[data-product-root]'));
    return;
  }
  const cardGalleryControl = event.target.closest('[data-card-gallery-step]');
  if (cardGalleryControl) {
    event.preventDefault();
    const gallery = cardGalleryControl.closest('[data-card-gallery]');
    showCardGalleryImage(gallery, Number(gallery.dataset.cardIndex || 0) + Number(cardGalleryControl.dataset.cardGalleryStep));
    return;
  }
  const cartOpen = event.target.closest('[data-cart-open]');
  if (cartOpen) { event.preventDefault(); try { await Charmant.openCart(); } catch { Charmant.toast('Puedes continuar desde el carrito completo.'); } return; }
  if (event.target.closest('[data-cart-close]')) { Charmant.closeCart(); return; }
  const cartChange = event.target.closest('[data-cart-change]');
  if (cartChange) {
    cartChange.disabled = true;
    try { await Charmant.changeCart(cartChange.dataset.cartChange, Number(cartChange.dataset.quantity)); }
    catch { Charmant.toast('No pudimos actualizar el carrito. Inténtalo de nuevo.'); }
    finally { if (cartChange.isConnected) cartChange.disabled = false; }
    return;
  }
  const pageChange = event.target.closest('[data-cart-page-change]');
  if (pageChange) {
    pageChange.disabled = true;
    const quantity = Math.max(Number(pageChange.dataset.currentQuantity) + Number(pageChange.dataset.cartPageChange), 0);
    try {
      await Charmant.changeCart(pageChange.dataset.cartItemKey, quantity);
      window.location.reload();
    } catch {
      pageChange.disabled = false;
      Charmant.toast('No pudimos actualizar la cantidad.');
    }
    return;
  }
  if (event.target.closest('[data-filter-toggle]')) { document.querySelector('[data-collection-filters]')?.classList.toggle('is-open'); document.body.classList.toggle('filters-open'); return; }
  const zoom = event.target.closest('[data-gallery-zoom]');
  if (zoom) {
    event.preventDefault();
    const lightbox = document.querySelector('[data-product-lightbox]');
    if (lightbox) {
      productLightboxTrigger = zoom;
      productLightboxItems = Array.from(document.querySelectorAll('[data-product-gallery] [data-gallery-zoom]'));
      showProductLightboxImage(productLightboxItems.indexOf(zoom));
      lightbox.hidden = false;
      document.body.classList.add('lightbox-open');
      lightbox.querySelector('[data-product-lightbox-close]')?.focus({ preventScroll: true });
    }
    return;
  }
  const lightboxStep = event.target.closest('[data-product-lightbox-step]');
  if (lightboxStep) { event.preventDefault(); showProductLightboxImage(productLightboxIndex + Number(lightboxStep.dataset.productLightboxStep)); return; }
  if (event.target.closest('[data-product-lightbox-close]') || event.target.matches('[data-product-lightbox]')) { closeProductLightbox(); return; }
  if (event.target.matches('[data-product-lightbox-image]')) {
    if (Date.now() < suppressProductLightboxClickUntil) return;
    const lightbox = event.target.closest('[data-product-lightbox]');
    if (!lightbox) return;
    const image = event.target;
    if (image.naturalWidth > image.clientWidth * 1.15) {
      lightbox.style.setProperty('--lightbox-zoom-width', `${Math.min(image.naturalWidth, window.innerWidth * 2)}px`);
      lightbox.classList.toggle('is-zoomed');
    }
    return;
  }
  const soon = event.target.closest('[data-coming-soon]');
  if (soon) { event.preventDefault(); Charmant.toast(soon.dataset.message || 'La colección Caballero llegará muy pronto.'); return; }
  if (event.target.closest('[data-mobile-toggle]')) {
    const toggle = event.target.closest('[data-mobile-toggle]');
    const menu = document.querySelector('[data-mobile-nav]');
    if (!menu) return;
    const willOpen = menu.hidden;
    Charmant.closePanels();
    if (willOpen) {
      const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0;
      menu.style.top = `${Math.max(0, headerBottom)}px`;
    } else {
      menu.style.removeProperty('top');
    }
    menu.hidden = !willOpen;
    toggle.setAttribute('aria-expanded', String(willOpen));
    document.body.classList.toggle('menu-open', willOpen);
    return;
  }
  if (event.target.closest('[data-search-toggle]')) { const toggle = event.target.closest('[data-search-toggle]'); const panel = document.querySelector('[data-search-panel]'); const willOpen = panel.hidden; Charmant.closePanels(); panel.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); document.body.classList.toggle('menu-open', willOpen); if (willOpen) window.setTimeout(() => panel.querySelector('input')?.focus(), 50); }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') { closeProductLightbox(); Charmant.closeCart(); Charmant.closePanels(); document.querySelector('[data-collection-filters]')?.classList.remove('is-open'); document.body.classList.remove('filters-open'); return; }
  const lightbox = document.querySelector('[data-product-lightbox]');
  if (lightbox && !lightbox.hidden && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
    event.preventDefault();
    showProductLightboxImage(productLightboxIndex + (event.key === 'ArrowLeft' ? -1 : 1));
  }
});
document.addEventListener('touchstart', (event) => {
  const lightbox = event.target.closest('[data-product-lightbox]');
  if (!lightbox || lightbox.hidden || lightbox.classList.contains('is-zoomed') || event.touches.length !== 1) return;
  productLightboxTouchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
}, { passive: true });
document.addEventListener('touchend', (event) => {
  const lightbox = event.target.closest('[data-product-lightbox]');
  if (!lightbox || lightbox.hidden || !productLightboxTouchStart || lightbox.classList.contains('is-zoomed')) return;
  const dx = event.changedTouches[0].clientX - productLightboxTouchStart.x;
  const dy = event.changedTouches[0].clientY - productLightboxTouchStart.y;
  productLightboxTouchStart = null;
  if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) {
    suppressProductLightboxClickUntil = Date.now() + 400;
    showProductLightboxImage(productLightboxIndex + (dx < 0 ? 1 : -1));
  }
}, { passive: true });
document.addEventListener('touchcancel', () => { productLightboxTouchStart = null; }, { passive: true });
window.addEventListener('scroll', () => document.querySelector('[data-header-shell]')?.classList.toggle('is-scrolled', window.scrollY > 40), { passive: true });

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-ajax-product-form]')) return;
  event.preventDefault();
  if (form.querySelector('[data-product-radio]') && !form.querySelector('[data-product-radio]:checked')) {
    focusProductSizes(form.closest('[data-product-root]'));
    Charmant.toast('Elige una talla para continuar.');
    return;
  }
  const buyNow = event.submitter?.matches('[data-buy-now]') || false;
  const buttons = [form.querySelector('.product-add'), document.querySelector('[data-buy-now]')].filter(Boolean);
  if (buttons.some((button) => button.dataset.submitting === 'true')) return;
  const originalLabels = buttons.map((button) => button.textContent);
  buttons.forEach((button) => { button.dataset.submitting = 'true'; button.disabled = true; button.textContent = 'AGREGANDO…'; });
  try {
    const response = await fetch(`${Charmant.routes.add}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'No se pudo agregar');
    }
    if (buyNow) {
      const checkoutForm = document.createElement('form');
      checkoutForm.method = 'post';
      checkoutForm.action = Charmant.routes.cart;
      checkoutForm.hidden = true;
      const checkoutButton = document.createElement('button');
      checkoutButton.type = 'submit';
      checkoutButton.name = 'checkout';
      checkoutForm.append(checkoutButton);
      document.body.append(checkoutForm);
      checkoutForm.requestSubmit(checkoutButton);
    } else {
      await Charmant.openCart();
      Charmant.toast('Prenda agregada al carrito');
    }
  } catch (error) { Charmant.toast(error.message || 'Revisa la talla seleccionada e inténtalo de nuevo.'); }
  finally { buttons.forEach((button, index) => { button.disabled = false; button.textContent = originalLabels[index]; delete button.dataset.submitting; }); }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sort-by]')) event.target.form.submit();
  if (event.target.matches('[data-product-select], [data-product-radio]')) {
    const source = event.target.matches('select') ? event.target.selectedOptions[0] : event.target;
    const root = event.target.closest('[data-product-root]');
    const price = root?.querySelector('[data-product-price]');
    const selected = root?.querySelector('[data-selected-variant]');
    const add = event.target.closest('form')?.querySelector('.product-add');
    if (price && source.dataset.price) {
      price.innerHTML = source.dataset.comparePrice
        ? `<s>${Charmant.escape(source.dataset.comparePrice)}</s><strong>${Charmant.escape(source.dataset.price)}</strong><small>Ahorra ${Charmant.escape(source.dataset.saving)} · ${Charmant.escape(source.dataset.discount)}% DE DESCUENTO</small>`
        : `<strong>${Charmant.escape(source.dataset.price)}</strong>`;
    }
    if (selected) selected.textContent = source.dataset.variantTitle || source.textContent || source.value;
    if (add) { add.type = source.disabled ? 'button' : 'submit'; add.disabled = source.disabled; add.textContent = source.disabled ? 'AGOTADO' : (root?.dataset.demoProduct === 'true' ? 'AGREGAR PRODUCTO DEMO' : 'AGREGAR AL CARRITO'); }
    const mobilePrice = root?.querySelector('[data-mobile-price]');
    const mobileSelection = root?.querySelector('[data-mobile-selection]');
    const mobileBuy = root?.querySelector('[data-buy-now]');
    if (mobilePrice && source.dataset.price) mobilePrice.textContent = source.dataset.price;
    if (mobileSelection) mobileSelection.textContent = `Elegida: ${source.dataset.variantTitle || source.textContent || source.value}`;
    if (mobileBuy) { mobileBuy.type = source.disabled ? 'button' : 'submit'; mobileBuy.disabled = source.disabled; mobileBuy.textContent = source.disabled ? 'AGOTADO' : 'COMPRAR AHORA'; }
    const stock = root?.querySelector('[data-stock-note]');
    const delivery = root?.querySelector('[data-delivery-message]');
    const production = root?.querySelector('[data-production-message]');
    const totalDelivery = root?.querySelector('[data-total-delivery]');
    const quantity = root?.querySelector('input[name="quantity"]');
    const inventory = Number(source.dataset.inventory || 0);
    if (delivery) {
      const title = source.dataset.variantTitle || source.textContent || '';
      const inStock = source.dataset.inventoryTracked === 'true' && inventory > 0;
      const madeToOrder = source.dataset.inventoryPolicy === 'continue' && !inStock;
      delivery.textContent = source.disabled
        ? 'Esta talla está agotada.'
        : inStock
        ? `Talla ${title} en stock.`
        : madeToOrder
          ? 'Esta talla se confecciona bajo pedido.'
          : 'Pieza disponible para comprar.';
      if (production) production.hidden = !madeToOrder || source.disabled;
      if (totalDelivery) totalDelivery.hidden = source.disabled;
      if (totalDelivery) totalDelivery.textContent = madeToOrder
        ? 'Entrega en máximo 18 días hábiles desde la confirmación del pago.'
        : 'Entrega en máximo 8 días hábiles desde la confirmación del pago.';
    }
    if (quantity) {
      if (source.dataset.inventoryTracked === 'true' && source.dataset.inventoryPolicy === 'deny') quantity.max = String(Math.max(inventory, 1));
      else quantity.removeAttribute('max');
      if (Number(quantity.value) > Number(quantity.max || quantity.value)) quantity.value = quantity.max;
    }
    if (stock) {
      const showLowStock = source.dataset.inventoryTracked === 'true' && inventory > 0 && inventory < 8;
      stock.hidden = !showLowStock;
      if (showLowStock) stock.textContent = 'PIEZA DE EDICIÓN LIMITADA';
    }
    if (source.value) window.history.replaceState({}, '', `${window.location.pathname}?variant=${source.value}`);
  }
});
const charmantPolicyTitles={
  '/policies/privacy-policy':'Política de privacidad y tratamiento de datos',
  '/policies/refund-policy':'Cambios, devoluciones, retracto y garantía',
  '/policies/shipping-policy':'Política de envíos y entregas',
  '/policies/terms-of-service':'Términos y condiciones de uso y venta'
};
const charmantPolicyTitle=charmantPolicyTitles[window.location.pathname];
if(charmantPolicyTitle){
  const policyHeading=document.querySelector('.shopify-policy__title h1');
  if(policyHeading) policyHeading.textContent=charmantPolicyTitle;
}
